/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Responsibletenantusergroup3Inputs */

const en_entity_responsibletenantusergroup3 = /** @type {(inputs: Entity_Responsibletenantusergroup3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsible Tenant User Group`)
};

const de_entity_responsibletenantusergroup3 = /** @type {(inputs: Entity_Responsibletenantusergroup3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verantwortliche Mandanten-Benutzergruppe`)
};

/**
* | output |
* | --- |
* | "Responsible Tenant User Group" |
*
* @param {Entity_Responsibletenantusergroup3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_responsibletenantusergroup3 = /** @type {((inputs?: Entity_Responsibletenantusergroup3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Responsibletenantusergroup3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_responsibletenantusergroup3(inputs)
	return de_entity_responsibletenantusergroup3(inputs)
});
export { entity_responsibletenantusergroup3 as "entity_responsibleTenantUserGroup" }